import * as yup from "yup";
import { toast } from "react-toastify";

import { BaseApplicationService } from "../../../domain/base/base-application-service";

export type MatrixCodeFileExtension = "jpeg" | "png";

export type MatrixCodeContextProps = {
  inputUrl: string;
  isValidInput: boolean;
  qrUrl: string;
  displayCode: boolean;
  fileExtension: MatrixCodeFileExtension;
  href: string;
  update: (inputUrl: string, qrUrl: string, displayCode: boolean) => void;
  updateFileExtension: (extension: MatrixCodeFileExtension) => void;
  onGenerateMatrixCode: () => void;
  onDownloadMatrixCode: () => void;
};

export class MatrixCodeService extends BaseApplicationService<MatrixCodeContextProps> {
  state: MatrixCodeContextProps = {
    inputUrl: "",
    isValidInput: false,
    qrUrl: "",
    displayCode: false,
    fileExtension: "jpeg",
    href: "",
    update: this.update.bind(this),
    updateFileExtension: this.updateFileExtension.bind(this),
    onGenerateMatrixCode: this.onGenerateMatrixCode.bind(this),
    onDownloadMatrixCode: this.onDownloadMatrixCode.bind(this),
  };

  update(inputUrl: string, qrUrl: string, displayCode: boolean) {
    this.setState({
      inputUrl: inputUrl,
      isValidInput: this.isValidInput(inputUrl),
      qrUrl: qrUrl,
      displayCode: displayCode,
    });
  }

  // TODO: yupのURLの正規表現だと、localhostはエラーになってしまうので、localhostのURLを許可するように修正する
  // ref. https://github.com/jquense/yup/blob/master/src/string.ts#L24-L26
  private isValidInput(inputUrl: string) {
    return (
      yup.string().url().isValidSync(inputUrl) &&
      yup.string().max(256).isValidSync(inputUrl)
    );
  }

  updateFileExtension(extension: MatrixCodeFileExtension) {
    this.setState({
      fileExtension: extension,
    });
  }

  onGenerateMatrixCode() {
    const { inputUrl } = this.state;
    if (inputUrl.length === 0) {
      toast.error("URLを入力してください。");
      return;
    }
    this.update(inputUrl, inputUrl, true);
  }

  onDownloadMatrixCode() {
    const { fileExtension } = this.state;
    const fileName = `matrix-code.${fileExtension}`;
    const canvas = document.getElementsByTagName(
      "canvas",
    )[0] as HTMLCanvasElement;
    const uri = canvas.toDataURL(`image/${fileExtension}`);
    const link = document.createElement("a");
    link.download = fileName;
    link.href = uri;
    link.click();
  }
}
